module.exports = __webpack_public_path__ + "img/chicken.731ccf4e.svg";